<div class="row p-3 m-0" [ngClass]="theme" *ngIf="theme && image">
    <div class="col-xl-1 col-lg-1 col-md-1 hidden-sm"></div>
    <div class="col-xl-5 col-lg-5 col-md-5 col-sm-6 col-xs-12">
        <h1 class="welcome-title">{{title | translate}}</h1> 
    </div>
    <div class="col-xl-5 col-lg-5 col-md-5 col-sm-6 hidden-xs justify-content-right">
        <img [src]="image" alt="" height="120" role="presentation"> 
    </div>
    <div class="col-xl-1 col-lg-1 col-md-1 hidden-sm"></div>
</div> 